// extracted by mini-css-extract-plugin
export default {"whatsCovered":"VMpOqU9B46TNrmVZPFXj","description":"hR9V9iG1s46i83ZHdFy1"};